export const transformApiDataToFilters = (apiData: any) => {
  // If the data is already in component format (has keys like 'Approval Status'), return it directly
  if (apiData['Approval Status']) {
    // Ensure Admin's pending is selected by default
    const transformedData = JSON.parse(JSON.stringify(apiData));
    if (transformedData['Approval Status'] && transformedData['Approval Status'].filterData) {
      transformedData['Approval Status'].filterData.forEach((category: any) => {
        if (category.id === 'admin' && category.filterData) {
          category.filterData.forEach((item: any) => {
            if (item.id === 'admin_pending') {
              item.isChecked = true;
            }
          });
        }
      });
    }
    return {
      filters: transformedData
    };
  }

  // Otherwise, transform API format to component format
  const transformedData: any = {};

  Object.entries(apiData).forEach(([key, value]: [string, any]) => {
    if (key === 'approvalStatus') {
      transformedData['Approval Status'] = {
        isChecked: false,
        collapsed: false,
        filterData: [
          {
            id: 'admin',
            value: 'Admin',
            isChecked: true,
            isSubCategory: true,
            filterData: [
              { id: 'admin_approved', value: 'Approved', isChecked: false },
              { id: 'admin_pending', value: 'Pending', isChecked: true },
              { id: 'admin_rejected', value: 'Rejected', isChecked: false },
            ]
          },
          {
            id: 'flm',
            value: 'FLM',
            isChecked: false,
            isSubCategory: true,
            filterData: [
              { id: 'flm_approved', value: 'Approved', isChecked: false },
              { id: 'flm_pending', value: 'Pending', isChecked: false },
              { id: 'flm_rejected', value: 'Rejected', isChecked: false },
            ]
          },
          {
            id: 'slm',
            value: 'SLM',
            isChecked: false,
            isSubCategory: true,
            filterData: [
              { id: 'slm_approved', value: 'Approved', isChecked: false },
              { id: 'slm_pending', value: 'Pending', isChecked: false },
              { id: 'slm_rejected', value: 'Rejected', isChecked: false },
            ]
          },
        ]
      };
    } else {
      const filterKey = key === 'completionStatus' ? 'Completion Status' :
                       key === 'countries' ? 'Country' :
                       key === 'states' ? 'State' :
                       key === 'hQs' ? 'HQ' :
                       key === 'divisions' ? 'Division' : key;

      if (Array.isArray(value)) {
        transformedData[filterKey] = {
          isChecked: false,
          collapsed: true,
          filterData: value.map((item: any) => {
            let id, displayValue;
            if (item.completionStatusId !== undefined) {
              id = item.completionStatusId;
              displayValue = item.completionStatusName;
            } else if (item.countryId !== undefined) {
              id = item.countryId;
              displayValue = item.countryName;
            } else if (item.stateId !== undefined) {
              id = item.stateId;
              displayValue = item.stateName;
            } else if (item.headQuaterId !== undefined) {
              id = item.headQuaterId;
              displayValue = item.headQuaterName;
            } else if (item.divisionId !== undefined) {
              id = item.divisionId;
              displayValue = item.divisionName;
            } else {
              id = item.id || item.value;
              displayValue = item.value || item.name;
            }

            return {
              id: id,
              value: displayValue,
              isChecked: false
            };
          })
        };
      }
    }
  });

  // Extract range values from API data and add them inside the filters
  const rangeValues = {
    maxDm: apiData.maxDM || 100000000,
    minDm: apiData.minDM || 0,
    maxDms: apiData.maxDMS || 10000000,
    minDms: apiData.minDMS || 0,
    maxSOW: apiData.maxSOW || 1000,
    minSOW: apiData.minSOW || 0
  };

  // Add range values into the filters object
  transformedData['maxDm'] = rangeValues.maxDm;
  transformedData['minDm'] = rangeValues.minDm;
  transformedData['maxDms'] = rangeValues.maxDms;
  transformedData['minDms'] = rangeValues.minDms;
  transformedData['maxSOW'] = rangeValues.maxSOW;
  transformedData['minSOW'] = rangeValues.minSOW;

  return {
    filters: transformedData
  };
};

